import React, { createContext, useState } from 'react';

export const ChatContext = createContext();

export function ChatProvider({ children }) {
  // Start with an empty chat log on first load.
  const [messages, setMessages] = useState([]);
  // We'll also store the sessionId here.
  const [sessionId, setSessionId] = useState(null);

  return (
    <ChatContext.Provider value={{ messages, setMessages, sessionId, setSessionId }}>
      {children}
    </ChatContext.Provider>
  );
}
